import { render, staticRenderFns } from "./common-detail-table.vue?vue&type=template&id=5f96e37a&scoped=true"
import script from "./common-detail-table.vue?vue&type=script&lang=js"
export * from "./common-detail-table.vue?vue&type=script&lang=js"
import style0 from "./common-detail-table.vue?vue&type=style&index=0&id=5f96e37a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f96e37a",
  null
  
)

export default component.exports